/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_PlaceholderInputs */

const en_palette_placeholder = /** @type {(inputs: Palette_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to, search a code or a name, or run an action…`)
};

/**
* | output |
* | --- |
* | "Go to, search a code or a name, or run an action…" |
*
* @param {Palette_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_placeholder = /** @type {((inputs?: Palette_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_placeholder(inputs)
});